export default abstract class BaseRepository<DataType extends object = object, IdType = string> {
    public abstract all(orderBy?: string): Promise<Array<DataType>>;
    public abstract get(uuid: IdType): Promise<DataType>;
    public abstract put(item: Array<DataType> | DataType): Promise<IdType>;
    public abstract update(uuid: IdType, changes: Partial<DataType>): Promise<void>;
    public abstract count(): Promise<number>;
    public abstract empty(): Promise<void>;
    public abstract delete(items: IdType | Array<IdType>): Promise<void>;
    public abstract each(callback: (item: DataType) => void): Promise<void>;

    /**
     * Access the source data directly, ensure instanceof is used.
     * TODO: Remove this.
     */
    public abstract raw(): any;
}
